export default __webpack_public_path__ + "static/media/Background 5_00021.6b2751ff.png";